import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { FOUNDER } from "../../data/content";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-[#F8FAFC]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="flex items-center gap-3 mb-14">
          <span className="h-[2px] w-10 bg-[#F5B800]" />
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1C9FD8]">About Us</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Founder photo — editorial, grayscale to color */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-4 group"
          >
            <div className="relative border border-slate-200 bg-white">
              <img
                src={FOUNDER.photo}
                alt={FOUNDER.name}
                className="founder-img w-full h-[420px] object-cover object-top"
              />
              <div className="p-6 border-t border-slate-200">
                <h3 data-testid="founder-name" className="font-display text-xl font-bold tracking-tight text-slate-900">
                  {FOUNDER.name}
                </h3>
                <p className="mt-1 text-sm font-medium text-[#1E4D8B]">{FOUNDER.role}</p>
                <p className="mt-0.5 text-xs uppercase tracking-[0.2em] text-slate-500">{FOUNDER.domain}</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="lg:col-span-8"
          >
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-slate-900">
              Building engineers who build the future.
            </h2>
            <p className="mt-8 text-base lg:text-lg text-slate-600 leading-relaxed">
              TechnoVeda Solutions delivers a wide range of engineering trainings for both freshers and laterals in
              embedded system design and development — imparting in-depth knowledge with utmost efficiency.
            </p>
            <p className="mt-4 text-base lg:text-lg text-slate-600 leading-relaxed">
              Beyond the technical core, we focus on improving soft skills and presentation skills to enhance the
              confidence of every participant.
            </p>

            <figure className="mt-10 border-l-2 border-[#F5B800] pl-6">
              <Quote className="w-8 h-8 text-[#F5B800] mb-3" />
              <blockquote className="font-display text-xl lg:text-2xl font-medium tracking-tight text-slate-900 leading-snug">
                {FOUNDER.quote}
              </blockquote>
              <figcaption className="mt-4 text-sm text-slate-500">— {FOUNDER.name}, {FOUNDER.role}</figcaption>
            </figure>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
